import React, { Component, Fragment } from "react"
import t from "../../../locale"
import logo from "../../images/articLogo.jpg"
import { FaInstagram, FaFacebook, FaGoogle } from "react-icons/fa"

import "./Footer.scss"

class Footer extends Component {
  state = {
    activeLanguage: "",
  };

  componentDidMount() {
    this.setState({
      activeLanguage: localStorage.getItem('locale') === null ? "en" : localStorage.getItem('locale')
    })
  }

  handleLocaleStorage = lang => {
    localStorage.setItem('locale', lang);
    window.location.reload()
  };

  render() {
    const { activeLanguage } = this.state;
    let en = activeLanguage === "en" ? "middle-content-language-link-active" : "middle-content-language-link";
    let cz = activeLanguage === "cz" ? "middle-content-language-link-active" : "middle-content-language-link";
    return (
      <footer id="footer">
        {typeof t === "function" ?
          <Fragment>
            <div className="row middle-content">
              <div className="col-sm-3 middle-content-div">
                <img className="middle-content-img" src={logo} alt="articBakehouse logo"/>
                {/* Social media div*/}
                <div className=" middle-content-social">
                  <div className="middle-content-social-inner">
                    <a target="_blank" href="https://www.facebook.com/articBakehouse/">
                    <FaFacebook className="social-icon"/>
                    </a>
                    <a target="_blank" href="https://www.instagram.com/artic_bakehouse/">
                    <FaInstagram className="social-icon"/>
                    </a>
                    <a target="_blank" href="https://www.google.com/search?source=hp&ei=qIGjXL2bJMqKmwWZpKrIBQ&q=artic+bakehouse&oq=artic+bake&gs_l=psy-ab.1.0.35i39i19j35i39j0i10i203l5j0i22i10i30l3.766.2005..3317...0.0..0.145.991.7j4......0....1..gws-wiz.....0..0j0i203._pkI4LfbQlU">
                    <FaGoogle className="social-icon"/>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-3 middle-content-div">
                <p>
                  {t("address")}
                </p>
                <p>
                  {t("country")}
                </p>
              </div>
              <div className="col-sm-3 middle-content-div">
                <p>
                  +420 111 222 333
                </p>
                <p>
                  articBakehouse@example.com
                </p>
              </div>
              <div className="middle-content-language col-sm-3">
                <span onClick={() => this.handleLocaleStorage("en")} className={en}>EN</span>
                <span onClick={() => this.handleLocaleStorage("cz")} className={cz}>CZ</span>
              </div>
            </div>
              <div className="rights">
                <p>{t("createdBy")} <span>Radivoje Dundjerovic</span>. {t("rightsReceived")} &copy; 2019.</p>
              </div>
          </Fragment>
          : null}
      </footer>
    )
  }
}

export default Footer